import { useApi } from "@shopexperts/shared";
import type { DraftLeadPublicResponse } from "@shopexperts/shared";

export type { DraftLeadPublicResponse };

export function useDraftLeadPrefill() {
    const api = useApi();

    async function fetchDraftForPrefill(token: string): Promise<DraftLeadPublicResponse | null> {
        try {
            const draft = await api.public.draftLeads.getByToken({
                params: { token },
            });

            if (draft.is_submitted) {
                return null;
            }

            return draft;
        } catch (error) {
            console.warn("[useDraftLeadPrefill] Could not load draft for prefill, falling back to an empty form:", error);
            return null;
        }
    }

    return {
        fetchDraftForPrefill,
    };
}
